import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import {
  BoxComponent,
  ButtonComponent,
  FormFieldComponent,
  InputComponent,
  LabelComponent,
} from '@recruitee/user-interface';

import { ApiClientService } from '../../api/api-client.service';

@Component({
  selector: 'auth-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.less'],
  standalone: true,
  imports: [ButtonComponent, BoxComponent, InputComponent, LabelComponent, FormFieldComponent],
})
export class SignInPageComponent {
  public token = '';
  private cdRef = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private destroyed$ = new Subject<void>();
  private api = inject(ApiClientService);

  public ngOnInit() {
    this.destroyRef.onDestroy(() => {
      this.destroyed$.next();
      this.destroyed$.complete();
    });
  }

  public signIn() {
    this.api
      .signIn({ email: '', password: '' })
      .pipe(takeUntil(this.destroyed$))
      .subscribe(token => {
        this.token = token;
        this.cdRef.detectChanges();
      });
  }
}
